export const addAbout = (about) => {
  const content = document.querySelector('[data-project-about-content]');

  if (about) {
    content.innerHTML = about;
    return
  }
  content.classList.add('hide')
}